
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/ai-driven-development",
      function () {
        return require("private-next-pages/download/ai-driven-development/index.tsx");
      }
    ]);
  